import styled from "styled-components";
import Text from "../text";

const Chips = styled(Text)`
  font-size: 10px;
  font-weight: 400;
`;

export default Chips;
